function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgViewLargeFilledIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.85 18.997c-5.165 0-8.268-3.295-10.375-5.565-.602-.65-.664-2.037 0-2.815C2.14 9.84 5.881 5 11.85 5c5.968 0 9.449 4.064 10.751 5.675.538.665.55 2.036-.065 2.757-1.37 1.668-4.456 5.565-10.686 5.565Zm.14-11.962a5.003 5.003 0 1 0 0 10.006 5.005 5.005 0 0 0 5.006-5.003 5.005 5.005 0 0 0-5.005-5.003Zm0 7.995a2.993 2.993 0 1 1 0-5.986 2.993 2.993 0 0 1 0 5.986Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgViewLargeFilledIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgViewLargeFilledIcon);
export default Memo;